import React from "react";
import { Button, Container } from "react-bootstrap";
import './AboutUsContent.css'
const AboutUsContent = () => {
  return (
    <div className="section-container about-us-content">
      <Container>
        <div className="row align-items-center">
          <div className="col-12 col-md-8 col-lg-7 col-xl-5">
            <div className="section-heading">
              <span>About Us</span>
              <h2>Who We Are?</h2>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut minima tenetur quis veritatis numquam reprehenderit autem hic quidem ea natus perspiciatis praesentium libero eaque, rerum saepe est alias consequatur nobis soluta sequi quod officiis. Excepturi consequuntur provident explicabo qui quisquam? Iusto explicabo sapiente vero saepe pariatundae exercitationem iusto veritatis maxime, quia, unde natus dignissimos autem culpa ea harum. Cumque!
              </p>
              <Button variant="light p-2">View Our News</Button>
            </div>
          </div>
          <div className="col-12 col-md-4 col-lg-5 col-xl-7">
            <div className="about-us-img">
              <img
                src={require("../../../images/about/Untitled (1000 × 1000 px).png")}
                alt=""
                className="w-100 h-100"
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AboutUsContent;
